import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "../features/auth/ProtectedRoute";
import PublicLayout from "../features/public/layout/PublicLayout";
import LoadingFallback from "../shared/components/LoadingFallback";

const HomePage = lazy(() => import("../features/public/pages/home/HomePage"));
const PiercingPage = lazy(() =>
  import("../features/public/pages/piercing/PiercingPage")
);
const LaserPage = lazy(() => import("../features/public/pages/laser/LaserPage"));
const LoginPage = lazy(() => import("../features/auth/LoginPage"));
const DashboardLayout = lazy(() =>
  import("../features/dashboard/layout/DashboardLayout")
);
const DashboardHome = lazy(() =>
  import("../features/dashboard/pages/DashboardHome")
);
const ClientsView = lazy(() =>
  import("../features/dashboard/pages/ClientsView")
);
const PaymentsView = lazy(() =>
  import("../features/dashboard/pages/PaymentsView")
);
const ReportsView = lazy(() =>
  import("../features/dashboard/pages/ReportsView")
);

const withFallback = (component) => (
  <Suspense fallback={<LoadingFallback />}>{component}</Suspense>
);

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PublicLayout>{withFallback(<HomePage />)}</PublicLayout>
        }
      />
      <Route
        path="/piercing"
        element={
          <PublicLayout>{withFallback(<PiercingPage />)}</PublicLayout>
        }
      />
      <Route
        path="/laser"
        element={
          <PublicLayout>{withFallback(<LaserPage />)}</PublicLayout>
        }
      />

      <Route path="/login" element={withFallback(<LoginPage />)} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            {withFallback(<DashboardLayout />)}
          </ProtectedRoute>
        }
      >
        <Route index element={withFallback(<DashboardHome />)} />
        <Route path="clients" element={withFallback(<ClientsView />)} />
        <Route path="payments" element={withFallback(<PaymentsView />)} />
        <Route path="reports" element={withFallback(<ReportsView />)} />
      </Route>

      <Route path="/dashboard/*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default AppRoutes;
